import { SvgIcon } from '@material-ui/core'

export default function MIDIIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 25 24" fill="none" {...props}>
            <g clipPath="url(#clip0_1152_39312)">
                <path
                    d="M3.75 0H2.25C1.00736 0 0 1.00736 0 2.25V21.75C0 22.9927 1.00736 24 2.25 24H5.25V12.75H4.5C4.08579 12.75 3.75 12.355 3.75 11.8676V0Z"
                    fill="currentColor"
                />
                <path
                    d="M6.75 12.75H7.5C7.91422 12.75 8.25 12.355 8.25 11.8676V0H9.75V11.8676C9.75 12.355 10.0858 12.75 10.5 12.75H11.25V24H6.75V12.75Z"
                    fill="currentColor"
                />
                <path
                    d="M12.75 12.75V24H17.25V12.75H16.5C16.0858 12.75 15.75 12.355 15.75 11.8676V0H14.25V11.8676C14.25 12.355 13.9142 12.75 13.5 12.75H12.75Z"
                    fill="currentColor"
                />
                <path
                    d="M20.25 0V11.8676C20.25 12.355 19.9142 12.75 19.5 12.75H18.75V24H21.75C22.9927 24 24 22.9927 24 21.75V2.25C24 1.00736 22.9927 0 21.75 0H20.25Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_1152_39312">
                    <rect width="24.2063" height="24" fill="currentColor" transform="translate(0.136719)" />
                </clipPath>
            </defs>
        </SvgIcon>
    )
}
